import React, { useState } from 'react';

function Header() {
  const [activeTab, setActiveTab] = useState('recharges');

  // Controls which mega-menu is expanded on mobile/tablet (accordion behavior).
  // Only one can be open at a time. This is intentionally separate from the
  // desktop hover-based behavior, which is left completely untouched.
  const [openMobileDropdown, setOpenMobileDropdown] = useState(null);

  const toggleMobileDropdown = (menu) => {
    setOpenMobileDropdown((prev) => (prev === menu ? null : menu));
  };

  // Mega-menu parent links (Softwares, Api Solutions, Services, Industries)
  // normally navigate or rely on :hover to reveal their panel on desktop.
  // On mobile/tablet (below the navbar-expand-lg breakpoint, 992px) hover
  // does not work reliably, so instead of navigating we intercept the tap
  // and toggle the panel open/closed via React state.
  const handleMegaMenuClick = (e, menu) => {
    if (typeof window !== 'undefined' && window.innerWidth < 992) {
      e.preventDefault();
      toggleMobileDropdown(menu);
    }
  };

  const apiSolutionsData = {
    recharges: [
      { name: "Recharge API", link: "/recharge_api" },
      { name: "Utility Bill Payment API", link: "/utility_bill_payment" },
      { name: "OTT Subscription API", link: "/ott_subscription_api" },
      { name: "Lapu Recharge API", link: "/recharge_api" },
      { name: "Fastag Recharge API", link: "/fastag_recharge_api" },
      { name: "Loan EMI Payment API", link: "/utility_bill_payment" },
      { name: "Metro Card Recharge API", link: "/recharge_api" },
      { name: "Insurance Payment API", link: "/utility_bill_payment" },
      { name: "Gift Voucher API", link: "/ott_subscription_api" },
      { name: "Courier Booking API", link: "/courier_booking_api" },
      { name: "LIC Payment API", link: "/utility_bill_payment" },
      { name: "Whatsapp API", link: "/crm_software_solutions" },
      { name: "Whatsapp Reseller API", link: "/crm_software_solutions" },
      { name: "SMS API", link: "/crm_software_solutions" },
      { name: "Whatsapp Business API", link: "/crm_software_solutions" }
    ],
    fintech: [
      { name: "AEPS Cash Withdrawal API", link: "/aeps_dmt_services" },
      { name: "DMT Money Transfer API", link: "/aeps_dmt_services" },
      { name: "Micro ATM (mATM) API", link: "/micro_atm_pos" },
      { name: "Bank Payout & Settlement API", link: "/aeps_dmt_services" },
      { name: "Aadhaar Pay API", link: "/aadhaar_pay_merchant" },
      { name: "BBPS Bill Payment API", link: "/utility_bill_payment" },
      { name: "Indo-Nepal Remittance API", link: "/indo_nepal_remittance" }
    ],
    travel: [
      { name: "Flight Booking API", link: "/flight_booking_api" },
      { name: "Bus Ticket Booking API", link: "/flight_booking_api" },
      { name: "Hotel Reservation API", link: "/flight_booking_api" }
    ],
    fetching: [
      { name: "Bill Amount Fetch API", link: "/utility_bill_payment" },
      { name: "DTH Customer Info Fetch API", link: "/recharge_api" },
      { name: "Mobile Operator & Circle Fetch API", link: "/recharge_api" }
    ],
    verification: [
      { name: "Verify API Suite", link: "/sprintverify" },
      { name: "Bank Account Penny Drop API", link: "/sprintverify" },
      { name: "PAN Card Verification API", link: "/sprintverify" },
      { name: "Aadhaar OTP Verification API", link: "/sprintverify" },
      { name: "GSTIN Status Verification API", link: "/sprintverify" },
      { name: "Vehicle RC Details API", link: "/sprintverify" }
    ]
  };

  const softwareRecharge = [
    { name: "B2B Mobile Recharge Software", link: "/b2b_recharge_software" },
    { name: "B2C Recharge Portal Software", link: "/b2b_recharge_software" },
    { name: "All-in-One Multi Recharge Software", link: "/b2b_recharge_software" },
    { name: "API Reselling Software", link: "/b2b_recharge_software" },
    { name: "Utility Bill Payment Software (BBPS)", link: "/utility_bill_payment" }
  ];

  const softwareBanking = [
    { name: "AEPS Software & Retailer Portal", link: "/aeps_dmt_services" },
    { name: "Domestic Money Transfer (DMT) Software", link: "/aeps_dmt_services" },
    { name: "Aadhaar Pay Merchant Software", link: "/aadhaar_pay_merchant" },
    { name: "Micro ATM (mATM) POS Software", link: "/micro_atm_pos" },
    { name: "Bank Payout & Settlement Platform", link: "/aeps_dmt_services" }
  ];

  const softwareEnterprise = [
    { name: "Verify API Platform", link: "/sprintverify" },
    { name: "Background & Verification Software", link: "/sprintverify" },
    { name: "FinTech Custom Software Development", link: "/android_app_development" },
    { name: "CRM Software Solutions", link: "/crm_software_solutions" },
    { name: "Inventory POS Billing Software", link: "/ecommerce_shopping" }
  ];

  const servicesDataCol1 = [
    { name: "Android Application Development", link: "/android_app_development" },
    { name: "Progressive Web Application", link: "/web_designing_services" },
    { name: "B2B, B2C & Reseller Platforms", link: "/b2b_recharge_software" },
    { name: "Hybrid Application Development", link: "/android_app_development" },
    { name: "Mobile Game Development", link: "/android_app_development" },
    { name: "Graphic & Logo Design", link: "/web_designing_services" }
  ];

  const servicesDataCol2 = [
    { name: "Web Designing Services", link: "/web_designing_services" },
    { name: "CMS Website Development", link: "/web_designing_services" },
    { name: "Digital Marketing Solutions", link: "/digital_marketing_solutions" },
    { name: "SEO SMO Services", link: "/digital_marketing_solutions" },
    { name: "Google PPC Services", link: "/digital_marketing_solutions" },
    { name: "Website Development", link: "/web_designing_services" }
  ];

  const servicesDataCol3 = [
    { name: "Linux & Windows Hosting", link: "/hosting_services" },
    { name: "Reseller Hosting", link: "/hosting_services" },
    { name: "VPS & Dedicated Server Hosting", link: "/hosting_services" },
    { name: "Payin and Payout API", link: "/aeps_dmt_services" },
    { name: "E-Commerce Shopping Website", link: "/ecommerce_shopping" }
  ];

  const industriesCol1 = [
    { name: "Recharge and Bill Payments", link: "/recharge_api" },
    { name: "Banking and Fintech", link: "/aeps_dmt_services" },
    { name: "Neo-Banking Platform", link: "/aeps_dmt_services" },
    { name: "E-commerce Shopping", link: "/ecommerce_shopping" },
    { name: "Retail & Merchant Services", link: "/aeps_dmt_services" }
  ];

  const industriesCol2 = [
    { name: "Identity Verification & Risk", link: "/sprintverify" },
    { name: "Business to Business (B2B)", link: "/b2b_recharge_software" },
    { name: "Corporate Sector", link: "/crm_software_solutions" },
    { name: "HRMS & Payroll Sector", link: "/crm_software_solutions" },
    { name: "Sales & Marketing", link: "/digital_marketing_solutions" }
  ];

  const industriesCol3 = [
    { name: "Travel & Hospitality", link: "/flight_booking_api" },
    { name: "Education Sector", link: "/web_designing_services" },
    { name: "Transportation & Logistics", link: "/courier_booking_api" },
    { name: "Healthcare Sector", link: "/web_designing_services" },
    { name: "Manufacturing Sector", link: "/ecommerce_shopping" }
  ];

  return (
    <header className="site_header header_layout_1">
      {/* Mobile-only overrides for the mega menus. These rules are scoped to
          max-width: 991.98px (the navbar-expand-lg breakpoint used below),
          so desktop's existing hover-based mega menu behavior is completely
          untouched above that width. On mobile, the panels are switched from
          "show on :hover" to "show when the parent <li> has .mobile_open",
          which is controlled by the openMobileDropdown React state above. */}
      <style>{`
        @media (max-width: 991.98px) {
          .main_menu_inner {
            overflow-x: hidden;
            max-width: 100vw;
          }

          .mega_menu_dropdown {
            position: relative;
            width: 100%;
          }

          .mega_menu_dropdown > a {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
          }

          /* Neutralize desktop hover-reveal and switch to accordion (closed by default) */
          .mega_menu_dropdown:hover .mega_menu_content_softwares,
          .mega_menu_dropdown:hover .mega_menu_content,
          .mega_menu_dropdown:hover .mega_menu_content_services,
          .mega_menu_dropdown:hover .mega_menu_content_industries,
          .mega_menu_content_softwares,
          .mega_menu_content,
          .mega_menu_content_services,
          .mega_menu_content_industries {
            position: static !important;
            display: block !important;
            visibility: visible !important;
            opacity: 1 !important;
            width: 100% !important;
            max-width: 100% !important;
            max-height: 0;
            margin: 0 !important;
            padding: 0 !important;
            overflow: hidden !important;
            box-shadow: none !important;
            border: none !important;
            transition: max-height 0.3s ease;
            pointer-events: none;
          }

          .mega_menu_dropdown.mobile_open > .mega_menu_content_softwares,
          .mega_menu_dropdown.mobile_open > .mega_menu_content,
          .mega_menu_dropdown.mobile_open > .mega_menu_content_services,
          .mega_menu_dropdown.mobile_open > .mega_menu_content_industries {
            max-height: 2000px;
            padding: 0.5rem 0 1rem 0.5rem !important;
            pointer-events: auto;
          }

          /* Collapse the 3-column desktop grids into a single readable column */
          .softwares_3col_grid,
          .services_3col_grid,
          .industries_3col_grid,
          .mega_pane_grid {
            display: block !important;
          }

          .softwares_3col_grid > div,
          .services_3col_grid > div,
          .industries_3col_grid > div {
            margin-bottom: 0.75rem;
          }

          .mega_item_link {
            display: block !important;
            width: 100% !important;
            white-space: normal !important;
            padding: 0.55rem 0.5rem !important;
            box-sizing: border-box;
          }

          .mega_col_title {
            padding: 0.4rem 0.5rem 0.2rem !important;
          }

          /* Api Solutions panel: stack the tab sidebar above its content pane */
          .mega_menu_content {
            display: flex;
            flex-direction: column;
          }

          .mega_sidebar {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            width: 100% !important;
          }

          .mega_tab_btn {
            flex: 1 1 47%;
            text-align: left;
            white-space: normal;
          }

          .mega_pane {
            width: 100% !important;
          }

          .mobile_chevron {
            transition: transform 0.25s ease;
            flex-shrink: 0;
          }

          .mobile_chevron.rotated {
            transform: rotate(180deg);
          }
        }
      `}</style>

      <div className="xb-header stricky">
        <div className="container-fluid px-lg-4">
          <div className="row align-items-center">
            
            {/* Logo */}
            <div className="col-lg-2 col-4">
              <div className="site_logo">
                <a className="site_link" href="/">
                  <img src="assets/images/1.png" alt="Mokshiq Logo White" />
                  <img src="assets/images/2.png" alt="Mokshiq Logo Black" />
                </a>
              </div>
            </div>

            {/* Navigation Menu */}
            <div className="col-lg-7 col-2">
              <nav className="main_menu navbar navbar-expand-lg">
                <div className="main_menu_inner collapse navbar-collapse justify-content-lg-center" id="main_menu_dropdown">
                  <ul className="main_menu_list unordered_list justify-content-center">
                    <li><a href="/">Home</a></li>
                    <li><a href="/about_us">About Us</a></li>

                    {/* Softwares Mega Menu */}
                    <li className={`mega_menu_dropdown ${openMobileDropdown === 'softwares' ? 'mobile_open' : ''}`}>
                      <a
                        href="/services"
                        onClick={(e) => handleMegaMenuClick(e, 'softwares')}
                        aria-expanded={openMobileDropdown === 'softwares'}
                      >
                        Softwares <i className={`fa-solid fa-angle-down ms-1 text-warning small mobile_chevron ${openMobileDropdown === 'softwares' ? 'rotated' : ''}`}></i>
                      </a>
                      <div className="mega_menu_content_softwares">
                        <div className="softwares_3col_grid">
                          <div>
                            <div className="mega_col_title"><i className="fa-solid fa-mobile-screen me-1 text-warning"></i> Recharge Software</div>
                            {softwareRecharge.map((item, idx) => (
                              <a key={idx} href={item.link} className="mega_item_link">
                                <span className="arrow">&gt;</span> {item.name}
                              </a>
                            ))}
                          </div>
                          <div>
                            <div className="mega_col_title"><i className="fa-solid fa-building-columns me-1 text-warning"></i> Banking Software</div>
                            {softwareBanking.map((item, idx) => (
                              <a key={idx} href={item.link} className="mega_item_link">
                                <span className="arrow">&gt;</span> {item.name}
                              </a>
                            ))}
                          </div>
                          <div>
                            <div className="mega_col_title"><i className="fa-solid fa-shield-halved me-1 text-warning"></i> Verification &amp; CRM</div>
                            {softwareEnterprise.map((item, idx) => (
                              <a key={idx} href={item.link} className="mega_item_link">
                                <span className="arrow">&gt;</span> {item.name}
                              </a>
                            ))}
                          </div>
                        </div>
                      </div>
                    </li>

                    {/* Api Solutions Mega Menu */}
                    <li className={`mega_menu_dropdown ${openMobileDropdown === 'apiSolutions' ? 'mobile_open' : ''}`}>
                      <a
                        href="#!"
                        onClick={(e) => handleMegaMenuClick(e, 'apiSolutions')}
                        aria-expanded={openMobileDropdown === 'apiSolutions'}
                      >
                        Api Solutions <i className={`fa-solid fa-angle-down ms-1 text-warning small mobile_chevron ${openMobileDropdown === 'apiSolutions' ? 'rotated' : ''}`}></i>
                      </a>
                      
                      <div className="mega_menu_content">
                        {/* Left Vertical Tabs */}
                        <div className="mega_sidebar">
                          <button 
                            className={`mega_tab_btn ${activeTab === 'recharges' ? 'active' : ''}`}
                            onMouseEnter={() => setActiveTab('recharges')}
                            onClick={() => setActiveTab('recharges')}
                          >
                            <i className="fa-solid fa-mobile-screen-button"></i> Recharges
                          </button>
                          <button 
                            className={`mega_tab_btn ${activeTab === 'fintech' ? 'active' : ''}`}
                            onMouseEnter={() => setActiveTab('fintech')}
                            onClick={() => setActiveTab('fintech')}
                          >
                            <i className="fa-solid fa-building-columns"></i> Fintech APIs
                          </button>
                          <button 
                            className={`mega_tab_btn ${activeTab === 'travel' ? 'active' : ''}`}
                            onMouseEnter={() => setActiveTab('travel')}
                            onClick={() => setActiveTab('travel')}
                          >
                            <i className="fa-solid fa-plane"></i> Travel APIs
                          </button>
                          <button 
                            className={`mega_tab_btn ${activeTab === 'fetching' ? 'active' : ''}`}
                            onMouseEnter={() => setActiveTab('fetching')}
                            onClick={() => setActiveTab('fetching')}
                          >
                            <i className="fa-solid fa-cloud-arrow-down"></i> Fetching APIs
                          </button>
                          <button 
                            className={`mega_tab_btn ${activeTab === 'verification' ? 'active' : ''}`}
                            onMouseEnter={() => setActiveTab('verification')}
                            onClick={() => setActiveTab('verification')}
                          >
                            <i className="fa-solid fa-id-card"></i> Verification APIs
                          </button>
                        </div>

                        {/* Right Content Pane */}
                        <div className="mega_pane">
                          <div className="mega_pane_grid">
                            {apiSolutionsData[activeTab]?.map((item, idx) => (
                              <a key={idx} href={item.link} className="mega_item_link">
                                <span className="arrow">&gt;</span> {item.name}
                              </a>
                            ))}
                          </div>
                        </div>
                      </div>
                    </li>

                    {/* Services Mega Menu */}
                    <li className={`mega_menu_dropdown ${openMobileDropdown === 'services' ? 'mobile_open' : ''}`}>
                      <a
                        href="/services"
                        onClick={(e) => handleMegaMenuClick(e, 'services')}
                        aria-expanded={openMobileDropdown === 'services'}
                      >
                        Services <i className={`fa-solid fa-angle-down ms-1 text-warning small mobile_chevron ${openMobileDropdown === 'services' ? 'rotated' : ''}`}></i>
                      </a>
                      <div className="mega_menu_content_services">
                        <div className="services_3col_grid">
                          <div>
                            {servicesDataCol1.map((item, idx) => (
                              <a key={idx} href={item.link} className="mega_item_link">
                                <span className="arrow">&gt;</span> {item.name}
                              </a>
                            ))}
                          </div>
                          <div>
                            {servicesDataCol2.map((item, idx) => (
                              <a key={idx} href={item.link} className="mega_item_link">
                                <span className="arrow">&gt;</span> {item.name}
                              </a>
                            ))}
                          </div>
                          <div>
                            {servicesDataCol3.map((item, idx) => (
                              <a key={idx} href={item.link} className="mega_item_link">
                                <span className="arrow">&gt;</span> {item.name}
                              </a>
                            ))}
                          </div>
                        </div>
                      </div>
                    </li>

                    {/* Industries Mega Menu */}
                    <li className={`mega_menu_dropdown ${openMobileDropdown === 'industries' ? 'mobile_open' : ''}`}>
                      <a
                        href="#!"
                        onClick={(e) => handleMegaMenuClick(e, 'industries')}
                        aria-expanded={openMobileDropdown === 'industries'}
                      >
                        Industries <i className={`fa-solid fa-angle-down ms-1 text-warning small mobile_chevron ${openMobileDropdown === 'industries' ? 'rotated' : ''}`}></i>
                      </a>
                      <div className="mega_menu_content_industries">
                        <div className="industries_3col_grid">
                          <div>
                            {industriesCol1.map((item, idx) => (
                              <a key={idx} href={item.link} className="mega_item_link">
                                <span className="arrow">&gt;</span> {item.name}
                              </a>
                            ))}
                          </div>
                          <div>
                            {industriesCol2.map((item, idx) => (
                              <a key={idx} href={item.link} className="mega_item_link">
                                <span className="arrow">&gt;</span> {item.name}
                              </a>
                            ))}
                          </div>
                          <div>
                            {industriesCol3.map((item, idx) => (
                              <a key={idx} href={item.link} className="mega_item_link">
                                <span className="arrow">&gt;</span> {item.name}
                              </a>
                            ))}
                          </div>
                        </div>
                      </div>
                    </li>

                    <li><a href="/career">Career</a></li>
                    <li><a href="/contact_us">Contact Us</a></li>
                  </ul>
                </div>
              </nav>
            </div>

            {/* Right Hotline & API Login Button */}
            <div className="col-lg-3 col-6">
              <ul className="btns_group p-0 unordered_list justify-content-end align-items-center flex-nowrap">
                <li>
                  <button className="mobile_menu_btn" type="button" data-bs-toggle="collapse" data-bs-target="#main_menu_dropdown" aria-expanded="false" aria-label="Toggle navigation">
                    <i className="far fa-bars"></i>
                  </button>
                </li>
                <li>
                  <a className="hotline_btn me-2" href="tel:+917311104571">
                    <span className="btn_icon">
                      <img src="assets/images/icons/icon_calling.svg" alt="Icon Calling" />
                    </span>
                    <span className="btn_label" data-text="+91 7311104571">+91 7311104571</span>
                  </a>
                </li>
                <li>
                  <a className="btn btn-warning btn-sm font-weight-bold text-dark px-3 py-2 text-nowrap" href="/contact_us">
                    Api Login
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;